// Geography Unit Tests and Exercises - Years 11-13
// Based on Vanuatu National Syllabus

// Year 11 Geography Unit Tests
export const year11GeographyUnitTests = {
  term1: {
    title: "Term 1 - Natural Processes",
    tests: [
      {
        title: "Unit Test 1: Earth Structure and Landforms",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Short Answer", marks: 20, questions: 5 },
          { name: "Section C: Diagram/Essay", marks: 15, questions: 2 }
        ]
      },
      {
        title: "Unit Test 2: Plate Tectonics and Volcanoes",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Short Answer", marks: 20, questions: 5 },
          { name: "Section C: Case Study", marks: 15, questions: 2 }
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Cultural Processes",
    tests: [
      {
        title: "Unit Test 3: Population and Migration",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Data Interpretation", marks: 20, questions: 4 },
          { name: "Section C: Essay", marks: 15, questions: 1 }
        ]
      },
      {
        title: "Unit Test 4: Urbanization and Tourism",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Short Answer", marks: 20, questions: 5 },
          { name: "Section C: Case Study", marks: 15, questions: 2 }
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Vanuatu Studies and Skills",
    tests: [
      {
        title: "Unit Test 5: Geography of Vanuatu",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Map Work", marks: 20, questions: 4 },
          { name: "Section C: Essay", marks: 15, questions: 1 }
        ]
      },
      {
        title: "Unit Test 6: Geographical Skills",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Map Reading", marks: 20, questions: 5 },
          { name: "Section B: Graph Construction", marks: 15, questions: 3 },
          { name: "Section C: Research Skills", marks: 15, questions: 2 }
        ]
      }
    ]
  }
};

// Year 12 Geography Unit Tests
export const year12GeographyUnitTests = {
  term1: {
    title: "Term 1 - Natural Hazards",
    tests: [
      {
        title: "Unit Test 1: Landforms and Relief",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Topographic Map Analysis", marks: 25, questions: 4 },
          { name: "Section C: Essay", marks: 20, questions: 1 }
        ]
      },
      {
        title: "Unit Test 2: Natural Hazards",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Case Study Analysis", marks: 25, questions: 3 },
          { name: "Section C: Disaster Management", marks: 20, questions: 2 }
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Human Geography",
    tests: [
      {
        title: "Unit Test 3: Population and Urbanization",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Data Analysis", marks: 25, questions: 4 },
          { name: "Section C: Essay", marks: 20, questions: 1 }
        ]
      },
      {
        title: "Unit Test 4: Tourism Management",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Short Answer", marks: 25, questions: 5 },
          { name: "Section C: Case Study", marks: 20, questions: 2 }
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Pacific Studies and Skills",
    tests: [
      {
        title: "Unit Test 5: Pacific Geography and Conservation",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Regional Analysis", marks: 25, questions: 4 },
          { name: "Section C: Essay", marks: 20, questions: 1 }
        ]
      },
      {
        title: "Unit Test 6: Advanced Geographical Skills",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Map Interpretation", marks: 25, questions: 5 },
          { name: "Section B: Statistical Analysis", marks: 20, questions: 4 },
          { name: "Section C: Research Report", marks: 15, questions: 1 }
        ]
      }
    ]
  }
};

// Year 13 Geography Unit Tests
export const year13GeographyUnitTests = {
  term1: {
    title: "Term 1 - Advanced Physical Geography",
    tests: [
      {
        title: "Unit Test 1: Earth Forces and Landforms",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Process Analysis", marks: 30, questions: 4 },
          { name: "Section C: Extended Response", marks: 30, questions: 2 }
        ]
      },
      {
        title: "Unit Test 2: Geomorphic Processes",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Case Study", marks: 30, questions: 3 },
          { name: "Section C: Essay", marks: 30, questions: 1 }
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Human and Global Geography",
    tests: [
      {
        title: "Unit Test 3: Migration and Economic Change",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Data Interpretation", marks: 30, questions: 4 },
          { name: "Section C: Extended Response", marks: 30, questions: 2 }
        ]
      },
      {
        title: "Unit Test 4: Global Issues",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Source Analysis", marks: 30, questions: 4 },
          { name: "Section C: Essay", marks: 30, questions: 1 }
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Research and Planning",
    tests: [
      {
        title: "Unit Test 5: Environmental Treaties and Conservation",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Treaty Analysis", marks: 30, questions: 4 },
          { name: "Section C: Extended Response", marks: 30, questions: 2 }
        ]
      },
      {
        title: "Final Skills Assessment",
        duration: "90 minutes",
        totalMarks: 90,
        sections: [
          { name: "Section A: Resource Interpretation", marks: 30, questions: 6 },
          { name: "Section B: Planning Application", marks: 30, questions: 3 },
          { name: "Section C: Research Design", marks: 30, questions: 2 }
        ]
      }
    ]
  }
};

// Year 11 Geography Exercises
export const year11GeographyExercises = {
  unit1: {
    title: "Earth Structure and Landforms",
    exercises: [
      {
        title: "Rock Type Identification",
        type: "Practical",
        instructions: "Identify and classify the following rock samples",
        questions: [
          "Describe three characteristics of igneous rocks",
          "Explain how sedimentary rocks form",
          "Give two examples of metamorphic rocks found in the Pacific"
        ]
      },
      {
        title: "Earth Layers Diagram",
        type: "Diagram",
        instructions: "Draw and label a cross-section of Earth's layers",
        questions: [
          "Label all four main layers with their approximate depths",
          "Indicate which layers are solid and which are liquid",
          "Explain why the inner core is solid despite high temperatures"
        ]
      }
    ]
  },
  unit2: {
    title: "Plate Tectonics",
    exercises: [
      {
        title: "Plate Boundary Mapping",
        type: "Map Work",
        instructions: "On the provided map, identify and label plate boundaries",
        questions: [
          "Mark and name the three types of plate boundaries",
          "Identify the plate boundary nearest to Vanuatu",
          "Explain why Vanuatu experiences frequent earthquakes"
        ]
      },
      {
        title: "Volcano Case Study",
        type: "Research",
        instructions: "Research a Vanuatu volcano and complete the following",
        questions: [
          "Describe the type and characteristics of the volcano",
          "Explain the hazards it presents to nearby communities",
          "Suggest disaster preparedness measures"
        ]
      }
    ]
  },
  unit3: {
    title: "Population Studies",
    exercises: [
      {
        title: "Population Pyramid Analysis",
        type: "Data Analysis",
        instructions: "Analyze the provided population pyramids",
        questions: [
          "Describe the shape and what it indicates about the population",
          "Calculate the dependency ratio",
          "Predict future population trends based on the pyramid"
        ]
      },
      {
        title: "Migration Survey",
        type: "Fieldwork",
        instructions: "Conduct a survey on migration in your community",
        questions: [
          "Identify push and pull factors for local migration",
          "Interview someone who has migrated about their experience",
          "Present your findings in a short report"
        ]
      }
    ]
  },
  unit4: {
    title: "Map Skills",
    exercises: [
      {
        title: "Grid Reference Practice",
        type: "Skills Practice",
        instructions: "Use the provided topographic map to answer questions",
        questions: [
          "Give 4-figure grid references for marked locations",
          "Give 6-figure grid references for specific features",
          "Calculate distances using the scale"
        ]
      },
      {
        title: "Cross-Section Drawing",
        type: "Practical",
        instructions: "Draw a cross-section from the topographic map",
        questions: [
          "Identify the start and end points",
          "Plot elevation points accurately",
          "Label significant features on your cross-section"
        ]
      }
    ]
  }
};

// Year 12 Geography Exercises
export const year12GeographyExercises = {
  unit1: {
    title: "Natural Hazards",
    exercises: [
      {
        title: "Hazard Mapping",
        type: "GIS/Map Work",
        instructions: "Create a hazard map for a local area",
        questions: [
          "Identify areas at risk from flooding, cyclones, or earthquakes",
          "Explain the factors that make these areas vulnerable",
          "Suggest mitigation strategies for each hazard"
        ]
      },
      {
        title: "Cyclone Pam Case Study",
        type: "Research",
        instructions: "Analyze the impacts and responses to Cyclone Pam (2015)",
        questions: [
          "Describe the physical and human impacts of the cyclone",
          "Evaluate the emergency response and relief efforts",
          "Discuss lessons learned for future disaster preparedness"
        ]
      }
    ]
  },
  unit2: {
    title: "Urbanization",
    exercises: [
      {
        title: "Urban Land Use Survey",
        type: "Fieldwork",
        instructions: "Conduct a land use survey in an urban area",
        questions: [
          "Map the different land uses in your study area",
          "Identify patterns and explain their distribution",
          "Compare to urban models studied in class"
        ]
      },
      {
        title: "Port Vila Analysis",
        type: "Case Study",
        instructions: "Analyze urbanization challenges in Port Vila",
        questions: [
          "Identify the main drivers of urban growth",
          "Describe the challenges facing informal settlements",
          "Propose solutions for sustainable urban development"
        ]
      }
    ]
  },
  unit3: {
    title: "Tourism",
    exercises: [
      {
        title: "Tourism Impact Assessment",
        type: "Analysis",
        instructions: "Assess the impacts of tourism on a local destination",
        questions: [
          "Identify positive and negative economic impacts",
          "Assess social and cultural impacts on the community",
          "Evaluate environmental impacts and sustainability"
        ]
      },
      {
        title: "Sustainable Tourism Plan",
        type: "Planning",
        instructions: "Develop a sustainable tourism plan for a Pacific destination",
        questions: [
          "Identify target markets and attractions",
          "Propose strategies to minimize negative impacts",
          "Include community involvement and benefit sharing"
        ]
      }
    ]
  },
  unit4: {
    title: "Pacific Studies",
    exercises: [
      {
        title: "Climate Change Impacts",
        type: "Research",
        instructions: "Research climate change impacts on a Pacific island nation",
        questions: [
          "Document observed and projected changes",
          "Assess vulnerabilities and impacts on communities",
          "Evaluate adaptation strategies being implemented"
        ]
      },
      {
        title: "SPREP Program Analysis",
        type: "Research",
        instructions: "Analyze a SPREP conservation program",
        questions: [
          "Describe the program's objectives and activities",
          "Assess its effectiveness and challenges",
          "Suggest improvements or extensions"
        ]
      }
    ]
  }
};

// Year 13 Geography Exercises
export const year13GeographyExercises = {
  unit1: {
    title: "Geomorphic Processes",
    exercises: [
      {
        title: "Process-Form Analysis",
        type: "Analysis",
        instructions: "Analyze the relationship between processes and landforms",
        questions: [
          "Select a landform and identify the processes that created it",
          "Draw diagrams showing process-form relationships",
          "Discuss how human activities affect these processes"
        ]
      },
      {
        title: "Coastal Process Study",
        type: "Fieldwork",
        instructions: "Conduct a coastal process investigation",
        questions: [
          "Measure and record wave characteristics",
          "Map coastal features and erosion/deposition zones",
          "Predict future changes based on current processes"
        ]
      }
    ]
  },
  unit2: {
    title: "Migration and Economy",
    exercises: [
      {
        title: "Migration Case Study",
        type: "Research",
        instructions: "Analyze a migration flow to or from the Pacific",
        questions: [
          "Identify push and pull factors",
          "Assess impacts on sending and receiving areas",
          "Evaluate policy responses to migration"
        ]
      },
      {
        title: "Economic Development Analysis",
        type: "Analysis",
        instructions: "Analyze economic development in a Pacific nation",
        questions: [
          "Identify key economic sectors and challenges",
          "Assess sustainability of current development path",
          "Propose strategies for economic diversification"
        ]
      }
    ]
  },
  unit3: {
    title: "Global Issues",
    exercises: [
      {
        title: "Climate Change Negotiations",
        type: "Simulation",
        instructions: "Participate in a climate negotiation simulation",
        questions: [
          "Represent the position of an assigned country",
          "Negotiate for outcomes that benefit your country",
          "Reflect on challenges of international cooperation"
        ]
      },
      {
        title: "Treaty Analysis",
        type: "Document Analysis",
        instructions: "Analyze an international environmental treaty",
        questions: [
          "Summarize the treaty's objectives and provisions",
          "Assess its implementation and effectiveness",
          "Evaluate its relevance to Pacific island nations"
        ]
      }
    ]
  },
  unit4: {
    title: "Research and Planning",
    exercises: [
      {
        title: "Research Proposal",
        type: "Planning",
        instructions: "Develop a geographic research proposal",
        questions: [
          "Formulate a clear research question",
          "Design appropriate methodology",
          "Plan data collection and analysis procedures"
        ]
      },
      {
        title: "Planning Evaluation",
        type: "Analysis",
        instructions: "Evaluate a real-world planning decision",
        questions: [
          "Identify stakeholders and their interests",
          "Assess the decision-making process used",
          "Critique the geographic considerations"
        ]
      }
    ]
  }
};

export default {
  year11UnitTests: year11GeographyUnitTests,
  year12UnitTests: year12GeographyUnitTests,
  year13UnitTests: year13GeographyUnitTests,
  year11Exercises: year11GeographyExercises,
  year12Exercises: year12GeographyExercises,
  year13Exercises: year13GeographyExercises
};
